export const fmtCoord = (lat, lng) => (lat == null || lng == null ? "—" : `${Number(lat).toFixed(5)}, ${Number(lng).toFixed(5)}`);

export const ACAO = {
  criar: { label: "Novo — será criado", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  atualizar: { label: "Existe — será atualizado", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  igual: { label: "Já cadastrado (sem alteração)", cls: "bg-slate-100 text-slate-600 border-slate-300" },
};

// Selecionados por padrão: novos e atualizações; "igual" fica desmarcado.
export const defaultSelection = (itens) => new Set(itens.filter((i) => i.acao !== "igual").map((i) => i.nome));

export const filtrarItens = (itens, aba, busca) => {
  const q = (busca || "").trim().toLowerCase();
  return itens.filter((i) => (aba === "todos" || i.acao === aba) && (!q || i.nome.toLowerCase().includes(q)));
};

// "Zona Norte · 3,4 km" — descrição curta da sugestão geográfica.
export const fmtDist = (s) => (s ? `${Number(s.dist_km).toFixed(1).replace(".", ",")} km do centro` : "");
export const fmtSugestao = (s) => (s ? `${s.zona_label} · ${fmtDist(s)}` : "");

// Região efetiva de um item: escolha manual > sugestão pela posição > região padrão.
export const regiaoEfetiva = (i, regiaoPorItem = {}, regiaoDefault = "") =>
  regiaoPorItem[i.nome] || i.sugestao?.regiao_id || regiaoDefault || "";

// Origem da região efetiva (para o rótulo "sugerida"/"padrão").
export const origemRegiao = (i, regiaoPorItem = {}, regiaoDefault = "") => {
  if (regiaoPorItem[i.nome]) return "manual";
  if (i.sugestao?.regiao_id) return "sugerida";
  return regiaoDefault ? "padrao" : "";
};

const precisaRegiao = (i) => i.acao === "criar" || (i.mudancas || []).includes("regiao");

export const toAplicarPayload = (itens, selected, regiaoPorItem = {}, regiaoDefault = "") =>
  itens.filter((i) => selected.has(i.nome) && i.acao !== "igual").map((i) => ({
    nome: i.nome, lat: i.lat, lng: i.lng, bairro_id: i.bairro_id || null, tipo: i.tipo || null,
    osm_type: i.osm_type || null, osm_id: i.osm_id || null,
    regiao_id: precisaRegiao(i) ? regiaoEfetiva(i, regiaoPorItem, regiaoDefault) || null : regiaoPorItem[i.nome] || null,
  }));

// Novos bairros sem região (nem manual, nem sugerida, nem padrão) — bloqueiam o salvar.
export const novosSemRegiao = (criar, regiaoPorItem, regiaoDefault) =>
  criar.filter((i) => !regiaoEfetiva(i, regiaoPorItem, regiaoDefault));
